import * as React from "react";
import { graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import { SliceZone } from "@prismicio/react";

import { Layout } from "../components/Layout";
import { components } from "../slices";

const PageTemplate = ({ data }) => {
  if (!data) return null;

  const pageContent = data.prismicPage;
  const page = pageContent.data || {};

  const { lang, type, url } = pageContent;
  const alternateLanguages = pageContent.alternate_languages || [];
  const activeDoc = {
    lang,
    type,
    url,
    alternateLanguages,
  };
  const topMenu = data.prismicTopMenu || {};
  const footer = data.prismicFooter || {};

  const seo = { title: page.seo_title, description: page.seo_description };

  return (
    <Layout
      topMenu={topMenu.data}
      activeDocMeta={activeDoc}
      footer={footer.data}
      seo={ seo }
    >

      {/* <h1 className="text-rose text-center h1 animate__animated animate__faster animate__fadeInDown">{page.display_title.text}</h1> */}

      <SliceZone
        slices={page.body}
        components={components}
        context={{
          page_title: page.display_title.text,
        }}
      />
    </Layout>
  );
};

export const query = graphql`
  query pageQuery($id: String, $lang: String) {
    prismicPage(id: { eq: $id }, lang: { eq: $lang }) {
      _previewable
      url
      uid
      type
      id
      lang
      alternate_languages {
        id
        type
        lang
        uid
      }
      data {
        display_title {
          text
          html
        }
        seo_title
        seo_description
        body {
          ... on PrismicSliceType {
            id
            slice_label
            slice_type
          }
          ...PageDataBodyFullWidthImage
          ...PageDataBodyInfoWithImage
          ...PageDataBodyJuicerSocialWall
          ...PageDataBodyContacts
          ...PageDataBodyAboutUsSection
          ...PageDataBodyVerticalSpacer
          ...PageDataBodyCardsCarousel
        }
      }
    }
    prismicTopMenu(lang: { eq: $lang }) {
      ...TopMenuFragment
    }
    prismicFooter(lang: { eq: $lang }) {
      ...FooterFragment
    }
  }
`;

export default withPrismicPreview(PageTemplate);
